var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-list-group',{attrs:{"flush":""}},_vm._l((_vm.items),function(node,idx){return _c('tree-view-item',{key:idx,attrs:{"node":node}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }